import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Limit condition validator
 * @returns
 */
export function LimitCondition(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return { limitCondition: true };
  };
}
